export const SCROLL_TO_REVIEWS = 'SCROLL_TO_REVIEWS';
export const SCROLL_TO_SECTION = 'SCROLL_TO_SECTION';
export const TOGGLE_SHORT_INFO = 'TOGGLE_SHORT_INFO';
export const SHOW_PAGE = 'SHOW_PAGE';
